import PropTypes from "prop-types";
import React from "react";
import { makeStyles } from "@fluentui/react-components";
import { shorthands } from "@griffel/react";

const useStyles = makeStyles({
  messageBody: {
    width: "100%",
    maxWidth: "100%",
    height: "auto",
    fontFamily: "Segoe UI",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px", // 133% of the font size
    color: "#4D4D4D",
    ...shorthands.flex("none"),
    wordWrap: "break-word", // Alternative for older browsers
    wordBreak: "break-word", // Handles breaking long words
    order: 0,
    flexGrow: 1,
  },
});

function FormattedText({ text }) {
  const classes = useStyles();
  return <div className={classes.messageBody} dangerouslySetInnerHTML={{ __html: text }} />;
}
FormattedText.propTypes = {
  text: PropTypes.string.isRequired,
};
export default FormattedText;
